import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocationCheckpoints.ts
function useLocationCheckpoints(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationCheckpointsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationCheckpoints };

//# sourceMappingURL=useLocationCheckpoints.js.map